import { Sparkles, XCircle, CheckCircle2 } from 'lucide-react';
import { Button } from '../ui/button';

export function AiSuggestionsPanel({ suggestions, targetCat, onAccept, onDismiss }) {
  if (!suggestions || suggestions.length === 0) return null;

  return (
    <div className="bg-purple-50 border border-purple-200 rounded-xl p-4 mb-6" data-testid="ai-suggestions-panel">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-purple-600" />
          <span className="text-sm font-semibold text-purple-900">AI-Suggested Causes {targetCat && `for ${targetCat}`}</span>
        </div>
        <button onClick={onDismiss} className="text-purple-400 hover:text-purple-600">
          <XCircle className="w-4 h-4" />
        </button>
      </div>
      <div className="space-y-2 max-h-[400px] overflow-y-auto">
        {suggestions.map((sug, i) => (
          <div key={`${sug.category}-${sug.cause}`} className="bg-white rounded-lg border border-purple-100 p-3" data-testid={`ai-suggestion-${i}`}>
            <div className="flex items-center justify-between gap-2 mb-1">
              <div className="flex items-center gap-2 min-w-0">
                <span className="text-[10px] font-bold uppercase tracking-wider text-purple-600 shrink-0">{sug.category}</span>
                {sug.relevance && (
                  <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-purple-100 text-purple-700 font-semibold shrink-0">
                    {Math.round(sug.relevance * 100)}%
                  </span>
                )}
              </div>
              <Button size="sm" className="h-6 px-2 text-xs bg-purple-600 hover:bg-purple-700 text-white shrink-0"
                onClick={() => onAccept(sug)} data-testid={`accept-suggestion-${i}`}>
                <CheckCircle2 className="w-3 h-3 mr-1" /> Accept
              </Button>
            </div>
            <p className="text-sm text-slate-800 font-medium">{sug.cause}</p>
            {sug.sub_causes?.length > 0 && (
              <div className="mt-1 flex flex-wrap gap-1">
                {sug.sub_causes.map((sc) => (
                  <span key={sc} className="text-[10px] bg-slate-100 text-slate-600 px-2 py-0.5 rounded">{sc}</span>
                ))}
              </div>
            )}
            {sug.classification_reason && (
              <p className="text-[10px] text-slate-400 mt-1 italic">{sug.classification_reason}</p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
